import type { Translations } from '@layers/app/stores/types/locale.ts'

import { SWEDISH_DATE_FORMAT_PLACEHOLDER_PATTERN } from '@layers/web/constants/date-format.ts'

const getDateOnDaysFromNow = (addDays: number) => {
  const date = new Date()
  date.setUTCDate(date.getUTCDate() + addDays)
  date.setUTCHours(0, 0, 0, 0)
  return date.toISOString()
}

const dateFormatToInputMask = (dateFormat: string) => dateFormat.replace(/[DMY]/g, '#')

const replaceDateFormatPlaceholder = (translations: Translations, placeholder: string): Translations =>
  Object.fromEntries(
    Object.entries(translations).map(([key, value]) => [
      key,
      value.replace(SWEDISH_DATE_FORMAT_PLACEHOLDER_PATTERN, placeholder),
    ])
  )

export {
  getDateOnDaysFromNow,
  dateFormatToInputMask,
  replaceDateFormatPlaceholder,
}